import React from "react";
import { Typography } from "@mui/material";
import Box from "@mui/material/Box";
import ViewImages from "../viewImages/viewImages";
import { VEHICLE_CATEGORY } from "../../../../constant/constant";
import { formatOrNA } from "../../../../utils/helper";

const sortVehicles = (vehicles) =>
  vehicles?.slice()?.sort((a, b) => {
    const aKey = a?.incVehicleId ?? a?.vehicleId ?? 0;
    const bKey = b?.incVehicleId ?? b?.vehicleId ?? 0;
    return aKey - bKey;
  });

// Fields the add-case form actually asks per vehicle category — keep this in
// sync with vehicle.jsx (company) / thirdPartyVehicle.jsx (3rd party) so the
// report never shows a field that category's form doesn't collect.
const VEHICLE_REPORT_FIELDS = {
  [VEHICLE_CATEGORY.COMPANY]: { influenceOfDrugs: true },
  [VEHICLE_CATEGORY.THIRD_PARTY]: { influenceOfDrugs: false },
};

const VehicleList = ({ title, vehicles, category }) => {
  const fields = VEHICLE_REPORT_FIELDS[category] ?? {};
  const imageSize = {
    size: "small",
  };
  if (!vehicles?.length) {
    return null;
  }
  return (
    <>
      <Typography className="title">{title}:</Typography>
      <div className="additionalListBox">
        {sortVehicles(vehicles)?.map((item, i) => {
          const image = [];
          const totalImg = item?.files?.map((i) => image.push(i.value));
          return (
            <>
              <div
                className="additionalList"
                key={item?.incVehicleId || item?.vehicleId || i}
              >
                <div className="subtitle">
                  {title} :{i + 1}
                </div>
                <Box className="columns">
                  <Typography className="listView">
                    Name of Driver:
                    <span className="font-w400">{item?.nameOfDriver}</span>
                  </Typography>
                  <Typography className="listView">
                    Vehicle Reg Number:
                    <span className="font-w400">{item?.regNumber}</span>
                  </Typography>
                </Box>
                <Box className="columns">
                  <Typography className="listView">
                    Unit Number:
                    <span className="font-w400">
                      {formatOrNA(item?.unitNumber)}
                    </span>
                  </Typography>
                  <Typography className="listView">
                    Make and Model:
                    <span className="font-w400">{formatOrNA(item?.model)}</span>
                  </Typography>
                </Box>
                <Typography className="listView">
                  Number of Occupants:
                  <span className="font-w400">
                    {item?.numberOfOccupants ? item?.numberOfOccupants : "N/A"}
                  </span>
                </Typography>

                <Typography className="listView columns">
                  <div className="columnsf">Was the Vehicle Towed?</div>
                  <InvolvementAnswer value={item?.isVehicleTowed} />
                </Typography>
                <Typography className="listView columns">
                  <div className="columnsf">
                    Was a Ticket Issued to this Driver?
                  </div>
                  <InvolvementAnswer value={item?.isTicketIssuedToDriver} />
                </Typography>
                {fields.influenceOfDrugs && (
                  <Typography className="listView columns">
                    <div className="columnsf">
                      Was the Driver Under Influence of Drugs/Alcohol?
                    </div>
                    <InvolvementAnswer value={item?.isInfluenceOfDrugs} />
                  </Typography>
                )}

                <Typography className="listView desNone">
                  Photos:
                  {image?.length > 0 ? (
                    <ViewImages
                      image={image}
                      imageSize={imageSize}
                      showName={false}
                    />
                  ) : (
                    <span className="font-w400">N/A</span>
                  )}
                </Typography>
              </div>
            </>
          );
        })}
      </div>
    </>
  );
};

const InvolvementAnswer = ({ value }) =>
  value === true ? (
    <div className="columnsl yesbtn">Yes</div>
  ) : value === false ? (
    <div className="columnsl nobtn">No</div>
  ) : (
    <div className="columnsl">
      <span className="font-w400">N/A</span>
    </div>
  );

const AdditionalVehicleDetails = ({ additionalData }) => {
  const companyVehicles = additionalData?.vehicles?.filter(
    (v) => v?.vehicleCategory === VEHICLE_CATEGORY.COMPANY,
  );
  const thirdPartyVehicles = additionalData?.vehicles?.filter(
    (v) => v?.vehicleCategory === VEHICLE_CATEGORY.THIRD_PARTY,
  );
  return (
    <>
      <div className="commonOveride">
        <Box className="commoninfoWrap">
          <Box className="commoninfoBox">
            <Box className="commoninfoleft">
              <Typography className="listView columns">
                <div className="columnsf">Were Company Vehicles Involved?</div>
                <InvolvementAnswer
                  value={additionalData?.wereCompanyVehiclesInvolved}
                />
              </Typography>
              <VehicleList
                title="Vehicle"
                vehicles={companyVehicles}
                category={VEHICLE_CATEGORY.COMPANY}
              />
            </Box>
            <Box className="commoninfoRight"></Box>
          </Box>
        </Box>
      </div>
      <div className="commonOveride">
        <Box className="commoninfoWrap">
          <Box className="commoninfoBox">
            <Box className="commoninfoleft">
              <Typography className="listView columns">
                <div className="columnsf">
                  Were 3rd Party Vehicles Involved?
                </div>
                <InvolvementAnswer
                  value={additionalData?.wereThirdPartyVehiclesInvolved}
                />
              </Typography>
              <VehicleList
                title="3rd Party Vehicle"
                vehicles={thirdPartyVehicles}
                category={VEHICLE_CATEGORY.THIRD_PARTY}
              />
            </Box>
            <Box className="commoninfoRight"></Box>
          </Box>
        </Box>
      </div>
    </>
  );
};

export default AdditionalVehicleDetails;
